import { Constants } from "./constants";

export class storeSearchRecents {

    public recentlySearched : Array<String> = new Array<String>();
    public type = 'storeSearchRecents';
    public _id =  '';

}



// WEBPACK FOOTER //
// ./src/app/shared/models/storeSearchRecents.ts